import styled, { keyframes } from 'styled-components';
import { lighten } from 'polished';
import { BiLoaderAlt } from 'react-icons/bi';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

export const Container = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  background-color: ${props => lighten(0.3, props.theme.colors.primaryLight)};
`;

export const LoadingImg = styled(BiLoaderAlt)`
  animation: ${rotate} 2s linear infinite;
  color: ${props => props.theme.colors.primary};
`;

export const LoadingText = styled.p`
  margin-top: 20px;
  font-size: ${props => props.theme.fontSizes.medium};
  color: ${props => props.theme.colors.primary};
`;
